import classNames from "classnames/bind";
import { ChevronRightOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/ChevronRightOutlined";
import styles from "./Trigger.module.scss";

const cx = classNames.bind(styles);

type Props = {
  label: string | React.ReactElement;
  onClick: () => void;
};

export const Trigger = ({ label, onClick }: Props) => {
  const labelClassNames = cx(styles.label, {
    labelString: typeof label === "string",
  });

  return (
    <button
      type="button"
      className={styles.trigger}
      onClick={onClick}
      data-testid="sideDrawer:trigger"
    >
      <div className={labelClassNames} data-testid="sideDrawer:trigger:label">
        {label}
      </div>
      <ChevronRightOutlined
        size="medium"
        dataTestId="sideDrawer:trigger:chevron"
      />
    </button>
  );
};
